import * as Yup from 'yup';
import { getOriginalUser } from '../services/utilisateur';
var originalUser = getOriginalUser();
var ERROR = {
    TROP_COURT: 'Trop court!',
    TROP_LONG: 'Trop grand!',
    REQUIRE: 'Obligatoire',
};
var DEFAULT_SCHEMA = {
    LIBELLE: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    NOM: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    PRENOM: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .nullable(),
    EMAIL: Yup.string()
        .email('Adresse email invalide')
        .required(ERROR.REQUIRE)
        .nullable(),
    SELECT_REQUIRE: Yup.number().required(ERROR.REQUIRE).nullable(),
    DATE: Yup.date().required(ERROR.REQUIRE).nullable(),
};
export var CollaborateurSchema = Yup.object().shape({
    CollaborateurTypeId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    Nom: DEFAULT_SCHEMA.NOM,
    Prenom: DEFAULT_SCHEMA.PRENOM,
    Email: DEFAULT_SCHEMA.EMAIL,
});
export var TypeSchema = Yup.object().shape({
    Libelle: DEFAULT_SCHEMA.LIBELLE,
});
export var CatalogueSchema = Yup.object().shape({
    CatalogueFamilleId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    Libelle: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(250, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
});
export var HabilitationSchema = Yup.object().shape({
    Libelle: DEFAULT_SCHEMA.LIBELLE,
});
export var UtilisateurSchema = Yup.object().shape({
    Login: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    Nom: DEFAULT_SCHEMA.NOM,
    Prenom: DEFAULT_SCHEMA.PRENOM,
    Email: DEFAULT_SCHEMA.EMAIL,
});
export var EquipeSchema = Yup.object().shape({
    CollaborateurId: DEFAULT_SCHEMA.SELECT_REQUIRE,
});
export var SectorisationSchema = Yup.object().shape({
    Objet: Yup.string().required(ERROR.REQUIRE).nullable(),
    CollaborateurId: Yup.number().when('Objet', {
        is: function (Objet) { return Objet === 'Collaborateur'; },
        then: DEFAULT_SCHEMA.SELECT_REQUIRE,
        otherwise: Yup.number().nullable(),
    }),
    GroupeId: Yup.number().when('Objet', {
        is: function (Objet) { return Objet === 'Groupe'; },
        then: DEFAULT_SCHEMA.SELECT_REQUIRE,
        otherwise: Yup.number().nullable(),
    }),
});
export var ObjectifsSchema = Yup.object().shape({
    objectifs: Yup.array().of(Yup.object().shape({
        ObjectifTypeId: DEFAULT_SCHEMA.SELECT_REQUIRE,
        Annee: Yup.number()
            .min(1000, ERROR.TROP_COURT)
            .max(9999, ERROR.TROP_LONG)
            .required(ERROR.REQUIRE)
            .nullable(),
    })),
});
export var ClientSchema = Yup.object().shape({
    Siret: Yup.string().when('IsSociete', {
        is: function (IsSociete) { return IsSociete; },
        then: Yup.string()
            .min(14, ERROR.TROP_COURT)
            .max(14, ERROR.TROP_LONG)
            .required(ERROR.REQUIRE)
            .nullable(),
        otherwise: Yup.string().nullable(),
    }),
    RaisonSociale: Yup.string().when('IsSociete', {
        is: function (IsSociete) { return IsSociete; },
        then: Yup.string()
            .min(2, ERROR.TROP_COURT)
            .max(50, ERROR.TROP_LONG)
            .required(ERROR.REQUIRE)
            .nullable(),
        otherwise: Yup.string().nullable(),
    }),
    Nom: Yup.string().when('IsSociete', {
        is: function (IsSociete) { return !IsSociete; },
        then: DEFAULT_SCHEMA.NOM,
        otherwise: Yup.string().nullable(),
    }),
    Prenom: Yup.string().when('IsSociete', {
        is: function (IsSociete) { return !IsSociete; },
        then: DEFAULT_SCHEMA.PRENOM,
        otherwise: Yup.string().nullable(),
    }),
    Email: Yup.string().when('IsSociete', {
        is: function (IsSociete) { return !IsSociete; },
        then: DEFAULT_SCHEMA.EMAIL,
        otherwise: Yup.string().nullable(),
    }),
});
export var AffaireSchema = Yup.object().shape({
    Libelle: DEFAULT_SCHEMA.LIBELLE,
    CollaborateurProprietaireId: Yup.number().when('IdAffaire', {
        is: function (IdAffaire) { return !IdAffaire && originalUser.Licence.UseVision; },
        then: DEFAULT_SCHEMA.SELECT_REQUIRE,
        otherwise: Yup.number().nullable(),
    }),
    AffaireTypeId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    ProbabiliteTypeId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    DateDebut: Yup.date().nullable(),
    DateFin: Yup.date().nullable(),
    OnlyYearMoisSignature: Yup.number()
        .min(1000, ERROR.TROP_COURT)
        .max(9999, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    OnlyMonthMoisSignature: Yup.number()
        .min(1, ERROR.TROP_COURT)
        .max(12, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
});
export var CloneAffaireSchema = Yup.object().shape({
    ClientId: Yup.number().when('OtherClient', {
        is: function (OtherClient) { return OtherClient; },
        then: DEFAULT_SCHEMA.SELECT_REQUIRE,
        otherwise: Yup.number().nullable(),
    }),
    Libelle: DEFAULT_SCHEMA.LIBELLE,
    CollaborateurProprietaireId: Yup.number().when('OtherClient', {
        is: function (OtherClient) { return OtherClient && originalUser.Licence.UseVision; },
        then: DEFAULT_SCHEMA.SELECT_REQUIRE,
        otherwise: Yup.number().nullable(),
    }),
    OnlyYearMoisSignature: Yup.number()
        .min(1000, ERROR.TROP_COURT)
        .max(9999, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    OnlyMonthMoisSignature: Yup.number()
        .min(1, ERROR.TROP_COURT)
        .max(12, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
});
export var OffresSchema = Yup.object().shape({
    CatalogueFamilleId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    CatalogueId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    Designation: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(250, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    offre__collaborateurs: Yup.array().of(Yup.object().shape({
        CollaborateurId: Yup.number().when('Deleted', {
            is: function (Deleted) { return !Deleted; },
            then: DEFAULT_SCHEMA.SELECT_REQUIRE,
            otherwise: Yup.number().nullable(),
        }),
        Pourcentage: Yup.number().when('Deleted', {
            is: function (Deleted) { return !Deleted; },
            then: Yup.number()
                .min(0, ERROR.TROP_COURT)
                .max(100, ERROR.TROP_LONG)
                .required(ERROR.REQUIRE)
                .nullable(),
            otherwise: Yup.number().nullable(),
        }),
    })),
});
export var ActiviteSchema = Yup.object().shape({
    ActiviteTypeId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    Etat: Yup.string().required(ERROR.REQUIRE).nullable(),
    Resultat: Yup.string().when('Etat', {
        is: function (Etat) { return Etat === 'C'; },
        then: Yup.string().required(ERROR.REQUIRE).nullable(),
        otherwise: Yup.string().nullable(),
    }),
    DateDebut: DEFAULT_SCHEMA.DATE,
    DateFin: DEFAULT_SCHEMA.DATE,
    activite__contacts: Yup.array().of(Yup.object().shape({
        ContactId: Yup.number().when('Deleted', {
            is: function (Deleted) { return !Deleted; },
            then: DEFAULT_SCHEMA.SELECT_REQUIRE,
            otherwise: Yup.number().nullable(),
        }),
    })),
    activite__collaborateurs: Yup.array().of(Yup.object().shape({
        CollaborateurId: Yup.number().when('Deleted', {
            is: function (Deleted) { return !Deleted; },
            then: DEFAULT_SCHEMA.SELECT_REQUIRE,
            otherwise: Yup.number().nullable(),
        }),
    })),
});
export var ContactSchema = Yup.object().shape({
    ContactTypeId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    Email: Yup.string().email('Adresse email invalide').nullable(),
    Nom: DEFAULT_SCHEMA.NOM,
});
export var DocumentSchema = Yup.object().shape({
    DocumentTypeId: DEFAULT_SCHEMA.SELECT_REQUIRE,
    Libelle: DEFAULT_SCHEMA.LIBELLE,
});
export var ChangementMotPasseSchema = Yup.object().shape({
    OldPassword: Yup.string().required(ERROR.REQUIRE).nullable(),
    NewPassword: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    NewPasswordCopy: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
});
export var ResetMotPasseSchema = Yup.object().shape({
    NewPassword: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
    NewPasswordCopy: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(50, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
});
export var DevisSchema = Yup.object().shape({
    Titre: DEFAULT_SCHEMA.LIBELLE,
    Numero: DEFAULT_SCHEMA.LIBELLE,
    Date: DEFAULT_SCHEMA.DATE,
    NomRecepteur: Yup.string()
        .min(2, ERROR.TROP_COURT)
        .max(250, ERROR.TROP_LONG)
        .required(ERROR.REQUIRE)
        .nullable(),
});
//# sourceMappingURL=ValidationSchema.js.map